// Leave-screen guard (Profile V2, 2026-10-19). A screen with unsaved changes registers a guard; every
// in-app way out (the screen's back button, App.js's hardware/browser back handler) asks it first. One
// guard at a time; no guard = leaving is always allowed. A throwing guard never traps the user.
let current = null;

export function setNavigationGuard(fn) {
  current = fn;
  return () => { if (current === fn) current = null; };
}

export function confirmNavigation() {
  if (!current) return true;
  try { return current() !== false; } catch { return true; }
}
